import { discoveryApiRef, useApi } from '@backstage/core-plugin-api';
import type { JSX } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserProfile } from '@backstage/plugin-user-settings';

export const Analytics = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element;
}) => {
  const discoveryApi = useApi(discoveryApiRef);
  const location = useLocation();
  const userProfile = useUserProfile();

  useEffect(() => {
    discoveryApi.getBaseUrl('analytics').then(value => {
      const url = `${value}/count`;
      const data = {
        name: 'backstage.pages.view',
        attributes: {
          action: location.pathname,
          search: location.search,
          userName: userProfile.displayName,
          email: userProfile.profile.email,
        },
      };
      fetch(url, {
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      });
    });
  }, [discoveryApi, location.pathname, location.search, userProfile]);

  return <>{children}</>;
};
